module.exports = __webpack_public_path__ + "static/media/pap-stem-poster.fda9991c.pdf";